exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes imbee-fadeIn{0%{opacity:0;transform:scale(.9)}to{opacity:1;transform:scale(1)}}.w-imbee-close-button[data-v-4be6c8e9]{position:absolute!important;right:16px!important;cursor:pointer;transition:all .3s ease;animation:imbee-fadeIn .6s ease}.w-imbee-close-button[data-v-4be6c8e9]:hover{transform:scale(1.18)}.w-imbee-header[data-v-4be6c8e9]{z-index:999;height:60px;min-height:60px;display:flex;align-items:center;justify-content:center;flex-direction:column;border:none;background-color:#fac654;position:relative}.w-imbee-header-subtitle[data-v-4be6c8e9]{margin-bottom:-6px;line-height:1.2;max-width:90%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4be6c8e9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 180
// module chunks = 0 1